import { type AppLanguage, getAppLanguage } from '@/i18n.ts';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Labels are not translated: each language is named in itself, so it can be found from either language
const LANGUAGES: { code: AppLanguage; label: string; name: string }[] = [
  { code: 'pl', label: 'PL', name: 'Polski' },
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'fr', label: 'FR', name: 'Français' },
];

const LanguageSwitcher: FC = () => {
  // useTranslation re-renders the switcher on every language change, also one made outside it
  const { i18n } = useTranslation();
  const isMobile = useMobileMediaQuery();
  const activeLanguage = getAppLanguage(i18n);

  const handleSelect = (language: AppLanguage) => () => {
    if (language !== activeLanguage) {
      void i18n.changeLanguage(language);
    }
  };

  return (
    <div
      aria-label="Język / Language"
      className="flex bg-white border-2 border-black z-50"
      role="group"
    >
      {LANGUAGES.map(({ code, label, name }) => {
        const isActive = code === activeLanguage;
        return (
          <button
            aria-label={name}
            aria-pressed={isActive}
            className={`${isMobile ? 'px-2 py-1 text-sm leading-5' : 'px-3 py-2'} font-bold ${
              isActive ? 'bg-black text-white' : 'bg-white text-black'
            }`}
            key={code}
            lang={code}
            onClick={handleSelect(code)}
            type="button"
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
